import { render } from "./Splash.vue?vue&type=template&id=54234d14&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=54234d14&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-54234d14"

export default script